<template>
  <el-card shadow="never">
    <div>
      <el-form class="ec-line020-021-022__form-contact" ref="form" :model="form" :rules="rules">
        <template v-if="!isLogin">
          <el-form-item :label="$t('common.memberInformation.fullName') + $t('common.requiredSeparator')">
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item prop="name01">
                  <el-input
                    v-model="form.name01"
                    :placeholder="$t('ec-line020.informationPlaceholder.lastNamePlaceholder')"
                    :maxlength="16"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="name02">
                  <el-input
                    v-model="form.name02"
                    :placeholder="$t('ec-line020.informationPlaceholder.firstNamePlaceholder')"
                    :maxlength="20"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item :label="$t('common.memberInformation.nameKana') + $t('common.requiredSeparator')">
            <el-row :gutter="16">
              <el-col :span="12">
                <el-form-item prop="kana01">
                  <el-input
                    v-model="form.kana01"
                    :placeholder="$t('ec-line020.informationPlaceholder.lastNameKanaPlaceholder')"
                    :maxlength="40"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="kana02">
                  <el-input
                    v-model="form.kana02"
                    :placeholder="$t('ec-line020.informationPlaceholder.firstNameKanaPlaceholder')"
                    :maxlength="40"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item :label="$t('common.memberInformation.email')" prop="email">
            <el-input
              v-model="form.email"
              :placeholder="$t('common.informationPlaceholder.emailPlaceholder')"
              :maxlength="255"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('common.memberInformation.emailConfirm')" prop="email_confirm">
            <el-input
              v-model="form.email_confirm"
              :placeholder="$t('common.informationPlaceholder.emailPlaceholder')"
              :maxlength="255"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('common.memberInformation.phoneNumber')" prop="phone_number">
            <div class="flex justify-start items-center">
              <el-input
                class="lg:w-36"
                inputmode="numeric"
                v-model="form.phone_number"
                :placeholder="$t('common.informationPlaceholder.phoneNumberPlaceholder')"
                :maxlength="11"
              ></el-input>
              <span class="ml-3 lg:block hidden text-xs text-gray-950">{{ $t('ec-line020.phoneNote') }}</span>
            </div>
          </el-form-item>
        </template>

        <el-form-item :label="$t('ec-lineQA.form.contactCategory')" prop="inquiry_category_id">
          <el-select v-model="form.inquiry_category_id">
            <el-option
              v-for="option in inqueryCategory"
              :key="option.id"
              :value="option.id"
              :label="option.name"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('ec-lineQA.form.contentsOfInquiry')" prop="contents">
          <el-input
            type="textarea"
            v-model="form.contents"
            :rows="6"
            :placeholder="$t('ec-lineQA.form.contentsOfInquiryPlaceholder')"
            :maxlength="100000"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="ec-line020-021-022__checkbox flex justify-center w-full items-center">
        <el-checkbox v-model="isAcceptTermsOfUse"></el-checkbox>
        <span class="ml-2 text-gray-950">
          <a class="font-bold underline" :href="Constants.SHOP_CONFIG.TERMS_OF_USE_URL" target="_blank">{{
            $t('ec-line020.checkbox.termsOfUse')
          }}</a
          ><span>{{ $t('ec-line020.checkbox.and') }}</span>
          <a class="font-bold underline" :href="Constants.SHOP_CONFIG.PRIVACY_POLICY_URL" target="_blank">{{
            $t('ec-line020.checkbox.privacyPolicy')
          }}</a
          ><span>{{ $t('ec-line020.checkbox.agree') }}</span>
        </span>
      </div>

      <inquiry-shop-infor />

      <div class="flex justify-center">
        <el-button class="submit-btn" @click="submit" :disabled="!isAcceptTermsOfUse">
          {{ $t('ec-lineQA.form.step1SubmitBtn') }}
        </el-button>
      </div>
    </div>
  </el-card>
</template>

<script>
import InquiryShopInfor from './InquiryShopInfor.vue'
export default {
  components: { InquiryShopInfor },
  props: {
    value: { type: Object, default: () => {} },
    master: { type: Object, default: () => {} },
  },
  data() {
    return {
      isAcceptTermsOfUse: false,
      rules: {
        name01: [
          this.Utils.validate.required(this.$t('common.validate.field.lastName')),
          this.Utils.validate.shiftjis(this.$t('common.validate.shiftjis')),
        ],
        name02: [
          this.Utils.validate.required(this.$t('common.validate.field.firstName')),
          this.Utils.validate.shiftjis(this.$t('common.validate.shiftjis')),
        ],
        kana01: [
          this.Utils.validate.required(this.$t('common.validate.field.lastNameKana')),
          this.Utils.validate.kanaFormat(this.$t('common.validate.field.lastNameKana')),
        ],
        kana02: [
          this.Utils.validate.required(this.$t('common.validate.field.firstNameKana')),
          this.Utils.validate.kanaFormat(this.$t('common.validate.field.firstNameKana')),
        ],
        email: [
          this.Utils.validate.required(this.$t('common.validate.field.email')),
          this.Utils.validate.emailFormat(this.$t('common.validate.field.email')),
        ],
        email_confirm: [
          this.Utils.validate.required(this.$t('common.validate.field.emailConfirm')),
          this.Utils.validate.emailFormat(this.$t('common.validate.field.emailConfirm')),
          {
            trigger: 'blur',
            validator: (_rule, value, callback) => {
              if (value !== this.form.email) {
                callback(new Error(this.$t('common.validate.confirm-email-check')))
              } else {
                callback()
              }
            },
          },
        ],
        contents: [this.Utils.validate.required(this.$t('ec-lineQA.form.contentsOfInquiry'))],
        inquiry_category_id: [this.Utils.validate.required(this.$t('ec-lineQA.form.contentsOfInquiry'))],
        phone_number: [
          this.Utils.validate.required(this.$t('common.memberInformation.phoneNumber')),
          this.Utils.validate.numberFormat(this.$t('common.validate.field.phoneNumber')),
          this.Utils.validate.phoneFormat(),
        ],
      },
    }
  },
  computed: {
    isLogin() {
      return this.$store.getters[`auth/isLogin`]
    },
    form: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    inqueryCategory() {
      return this.$store.state.master.inquiryCategory
    },
  },
  methods: {
    submit() {
      this.$refs.form.validate((isValid) => {
        if (!isValid) {
          this.handleError({ message: this.$t('common.messages.hasInvalidData') })
          return
        }

        this.$emit('submit')
      })
    },
  },
}
</script>

<style></style>
